import { Body, Row, styled } from '@teko/ds-desktop';
import { WishlistButton } from 'components/WishlistButton';
import { useProductDetailState } from 'contexts';
import { t } from 'i18n';
import { ShareButtons } from '../ShareButtons';

export const ShareAndWishlist = () => {
  const { product } = useProductDetailState();

  if (!product) {
    return null;
  }

  return (
    <Row align="bottom" justify="start" marginBottom="s12">
      <ShareButtons />
      <Divider />
      <Body level={1}>{t('Yêu thích')}</Body>
      <WishlistButton sku={product.sku} size="24" />
    </Row>
  );
};

const Divider = styled.div`
  ::before {
    content: '|';
    margin: 0 24px;
    color: #0000000f;
  }
`;
